const COLOR_CODE_MAP = {
  blue: "#0073b7",
  red: "#dd4b39",
  olive: "#3d9970",
  orange: "#ff851b",
  lime: "#01ff70",
  yellow: "#f39c12",
  green: "#00a65a",
  maroon: "#d81b60",
  teal: "#39cccc",
  navy: "#001f3f",
  fuchsia: "#f012be",
  purple: "#605ca8",
  aqua: "#00c0ef",
  black: "#000000",
};

const TYPE_ACTION_COLOR_MAP = {
  DEVICE: {
    NEW: "blue",
    ONLINE: "green",
    OFFLINE: "red",
    DELETE: "navy",
    UGPRADE: "blue",
    RESTART: "maroon",
  },
  INAPP: {
    CRASH: ["black", "yellow"],
  },
  DEPLOY: {
    NEW: "purple",
    DEPLOY: "purple",
  },
  ACCOUNT: {
    INVITE: "teal",
    REGISTER: "aqua",
  },
};

const TYPE_ACTION_ICON_MAP = {
  DEVICE: {
    NEW: "plus-square",
    ONLINE: "arrow-up",
    OFFLINE: "arrow-down",
    DELETE: "times",
    UPGRADE: "arrow-circle-o-up",
    RESTART: "refresh",
  },
  INAPP: {
    CRASH: ["medkit", "warning"],
  },
  DEPLOY: {
    NEW: "cloud-upload",
    DEPLOY: "cloud-download",
  },
  ACCOUNT: {
    INVITE: "envelope",
    REGISTER: "user-plus",
  },
};

const TYPE_ACTION_NAME_MAP = {
  DEVICE: {
    NEW: "New Device",
    ONLINE: "Device is Online",
    OFFLINE: "Device is Offline",
    DELETE: "Device Deleted",
    UPGRADE: "Device Upgraded",
    RESTART: "Device Started",
  },
  INAPP: {
    CRASH: ["Application Crash", "Application Warning"],
  },
  DEPLOY: {
    NEW: "App Uploaded",
    DEPLOY: "Strategy deployed",
  },
  ACCOUNT: {
    INVITE: "User Invited",
    REGISTER: "User Registered",
  },
};

export {
  COLOR_CODE_MAP,
  TYPE_ACTION_COLOR_MAP,
  TYPE_ACTION_ICON_MAP,
  TYPE_ACTION_NAME_MAP,
};
